import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import Link from "../components/Link";
import PrismicRichText from "../components/PrismicRichText";
import * as colors from "../constants/colors";
import renderButtons from "../helpers/renderButtons";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

const StlRoot = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  background: ${colors.heroOrange};
  margin-top: 28px;
  @media (min-width: 900px) {
    margin-top: 48px;
  }
`;

const StlBackgroundImage = styled.div`
  position: absolute;
  inset: 0;
  background-image: ${(props) =>
    props.imageUrl ? `url(${props.imageUrl})` : "none"};
  background-size: cover;
  background-position: center top;

  @media (min-width: 900px) {
    background-position: center;
  }
`;

const StlImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
`;

const StlInner = styled.div`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1480px;
  margin: 0 auto;
  min-height: 640px;
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 900px) {
    min-height: 690px;
    grid-template-columns: 1fr 1fr;
  }
`;

const StlCopySection = styled.div`
  padding: 36px 24px 48px;
  display: flex;
  justify-content: center;
  align-items: flex-end;

  h3 {
    margin: 0;
  }

  @media (min-width: 900px) {
    justify-content: flex-start;
    align-items: center;
    padding: 170px 72px 90px;
  }
`;

const StlCopyInner = styled.div`
  width: 100%;
  max-width: 520px;
  text-align: center;
  color: ${colors.white};

  @media (min-width: 900px) {
    text-align: left;
  }

  h1,
  h2,
  p {
    margin: 0 0 18px;
  }

  h1,
  h2 {
    margin-bottom: 24px;
    color: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: inherit;
  }

  p {
    font-size: 4.2rem;
    line-height: 4.8rem;
    letter-spacing: -0.12rem;
  }
`;

const StlButtonWrap = styled.div`
  margin-top: 28px;

  @media (min-width: 900px) {
    margin-top: 32px;
  }
`;

const BackgroundImageCallout = (slice) => {
  const theme = useTheme();
  const copy = get(slice, "primary.copy");
  const subCopy = get(slice, "primary.sub_copy");
  const imageUrl = get(slice, "primary.image.url");
  const mobileImageUrl = get(slice, "primary.image.Mobile.url");
  const buttons = get(slice, "items");
  const isTablet = useMediaQuery(theme.breakpoints.down("800"));

  if (!copy && !imageUrl) {
    return null;
  }

  return (
    <StlRoot>
      <StlBackgroundImage imageUrl={isTablet ? mobileImageUrl : imageUrl} />
      <StlImageOverlay />
      <StlInner>
        <StlCopySection>
          <StlCopyInner>
            {copy && <PrismicRichText render={copy} />}
            {subCopy && <PrismicRichText render={subCopy} />}
            <StlButtonWrap>{renderButtons(buttons)}</StlButtonWrap>
          </StlCopyInner>
        </StlCopySection>
      </StlInner>
    </StlRoot>
  );
};

export default BackgroundImageCallout;
